import React, { Component } from 'react';
import LimiteCompraSeleccionadoItem from './LimiteCompraSeleccionadoItem';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import OpcionDefecto from '../../../../../Common/Components/OpcionDefecto'
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

class LimiteCompraSeleccionado extends Component {
    constructor(props) {
        super(props)

        this.showMorePurchaseLimits = this.showMorePurchaseLimits.bind(this);
        this.showLessPurchaseLimits = this.showLessPurchaseLimits.bind(this);
    }

    showMorePurchaseLimits() {
        this.props.showMorePurchaseLimits();
    }

    showLessPurchaseLimits() {
        this.props.showLessPurchaseLimits();
    }

    render() {
        const { selectCheckBox, selectCombo } = this.props;
        let data = this.props.data.GET_LIMITE_COMPRA.filter(x => x.Checked == true && x.Id != 0);
        let itemCombo = this.props.data.GET_LIMITE_COMPRA.filter(x => x.Checked == true);
        let acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");

        itemCombo.forEach(function (item) {
            item.Descripcion = item.Id != 0 ? item.Valor : "Seleccione...";
        });

        let purchaseLimitsManagerButton = null;
     
        
        if (data.length > 0) {
            if (data.length > 10) {
                if (this.props.data.showMorePurchaseLimits == false) {
                    let originalDataSize = data.length;
                    data = data.slice(0, 10);
                    let morePurchaseLimitsText = "Ver todas (" + originalDataSize + ")...";
                    let morePurchaseLimits = <GenericSimpleButton buttonType="button" text={morePurchaseLimitsText} buttonClass="btn btn-link" onClick={this.showMorePurchaseLimits} />;
                    purchaseLimitsManagerButton = morePurchaseLimits;
                } else {
                    let closePurchaseLimitsList = <GenericSimpleButton buttonType="button" text="Cerrar la lista" buttonClass="btn btn-link" onClick={this.showLessPurchaseLimits} />;
                    purchaseLimitsManagerButton = closePurchaseLimitsList;
                }
            }
        }

        if (data) {
            var selectedPurchaseLimitsNodes = data.map((selectedPurchaseLimit) => {
                return <LimiteCompraSeleccionadoItem
                key={selectedPurchaseLimit.Id}
                id={selectedPurchaseLimit.Id}
                descripcion={selectedPurchaseLimit.Descripcion}
                codigo={selectedPurchaseLimit.Codigo}
                moneda={selectedPurchaseLimit.MonedaId}
                valor={selectedPurchaseLimit.Valor}
                removeSelectedPurchaseLimit={this.props.removeSelectedPurchaseLimit}
                />
            })
        }
        return (
            <div>
                {
                    data.length > 0 &&
                    <div className="row">
                        <div className="col-md-12">
                            <ul className="no-bullets">
                                {selectedPurchaseLimitsNodes}
                                {purchaseLimitsManagerButton}
                            </ul>
                        </div>
                    </div>
                }

                <OpcionDefecto
                    selecciono={(!this.props.data.ERROR_PRODUCT.seleccionoLimiteCompra&&this.props.data.agregoLDC)?1:0}
                    infoData={itemCombo}
                    referencia={"LimiteCompraDefaultId"}
                    valorCombo={this.props.data.LimiteCompraDefaultId}
                    valorChecked={this.props.data.LimiteCompraDefaultIntefaz}
                    selectCombo={(value) => selectCombo("LimiteCompraDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("LimiteCompraDefaultIntefaz", value)}
                    
                />
                {(!this.props.data.ERROR_PRODUCT.seleccionoLimiteCompra && !this.props.data.agregoLDC)
                    && <label className="error">{"Debe seleccionar al menos un l" + acentoLetraIminuscula + "mite de compra."}</label>}
            </div>
        );
    }
};

export default LimiteCompraSeleccionado;